import {Box, Button, Divider, Flex, FormControl, FormLabel, HStack, IconButton, Input, Stack, Text, useColorModeValue} from '@chakra-ui/react';
import { Link as DefaultLink, useParams } from 'react-router-dom';
import GooglePlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';
import React, { useCallback, useEffect, useState } from 'react';
import { companyCustomerType, customerFormTypes } from '../../types';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import { FiArrowLeft } from 'react-icons/fi';
import { ToastContainer } from 'react-toastify';
import { addCustomerFormValidation } from '../../utils';
import { updateCustomer } from '../../store/actions';
import { useFormik } from 'formik';

export const EditCustomer = () => {

    const { customer_id } = useParams();

    const [origin, setOrigin] = useState<any | null>(null);
    const [coords, setCoords] = useState<any | null>(null);
    const [customer, setCustomer] = useState<companyCustomerType | null>(null);

    const { is_updating_customer, customers } = useAppSelector(state => state.customersReducer);

    const dispatch: AppDispatch = useAppDispatch();

    const customerForm = useFormik({
        initialValues: {
            first_name: '',
            last_name: '',
            phone: '',
            email: '',
            address: '',
            coords: {
                lat: '',
                long: '',
            }
        },
        validationSchema: addCustomerFormValidation,
        onSubmit: (values: customerFormTypes) => {
            const address = origin?.label || customer?.address;
            const newValues: any = { ...customer, ...values, address, coords: { lat: coords?.lat || customer?.coords?.lat, long: coords?.long || customer?.coords?.long } };
            dispatch(updateCustomer(newValues));
            // alert(JSON.stringify(newValues, null, 2));
        }
    });

    const getCoords = useCallback(() => {
        origin && geocodeByAddress(origin?.label)
            .then((results: Array<any>) => getLatLng(results[0]))
            .then(({ lat, lng }: any) => {
                setCoords({ lat: lat, long: lng });
            }
            );
    }, []);

    const setFieldValues = () => {
        
        const [customer] = customers && customers?.filter((customer: companyCustomerType) => customer?.customer_id === customer_id);

        setCustomer(customer);

        customerForm.setFieldValue('first_name', customer?.first_name);
        customerForm.setFieldValue('last_name', customer?.last_name);
        customerForm.setFieldValue('phone', customer?.phone);
        customerForm.setFieldValue('email', customer?.email);
        customerForm.setFieldValue('address', customer?.address);
        customerForm.setFieldValue('coords.lat', customer?.coords?.lat);
        customerForm.setFieldValue('coords.long', customer?.coords?.long);

    };

    useEffect(() => {
        getCoords();
    }, []);

    useEffect(() => {
        setFieldValues();
    }, [customer]);

    return (
        <Flex
            minH={'-webkit-fill-available'}
            align={'center'}
            justify={'center'}
            // bg={useColorModeValue('gray.50', 'gray.800')}
            py={10}
        >
            <Stack>
                <Box
                    rounded={'lg'}
                    bg={useColorModeValue('white', 'gray.700')}
                    boxShadow={'lg'}
                    p={8}>
                    <Stack spacing={4}>
                    <HStack align={'center'}>
                            <Stack>
                                <IconButton variant={'ghost'} aria-label='go back' icon={<FiArrowLeft style={{ width: '24px', height: '24px' }} />} as={DefaultLink} to='/customers' />
                            </Stack>
                            <Stack>
                                <Text display={'flex'} fontSize={'lg'} fontWeight='medium' textAlign={'center'}>
                                    Edit customer.
                                </Text>
                            </Stack>
                        </HStack>
                        <Divider />
                        <Stack mb={3}>
                            <Text textAlign={'center'} fontSize={'lg'} color={'gray.600'}>
                                To enjoy all of our cool features ✌️
                            </Text>
                        </Stack>
                        <form onSubmit={customerForm.handleSubmit}>
                            <HStack>
                                <Box>
                                    <FormControl id="first_name" isRequired mb={customerForm.errors.first_name ? 0 : 5}>
                                        <FormLabel>First name</FormLabel>
                                        <Input name='first_name' type="text" value={customerForm.values.first_name} onChange={customerForm.handleChange} />
                                        {customerForm.errors.first_name && <Text fontSize='sm' color='red.400'>{customerForm.errors.first_name}</Text>}
                                    </FormControl>
                                </Box>
                                <Box>
                                    <FormControl id="last_name" isRequired mb={customerForm.errors.last_name ? 0 : 5}>
                                        <FormLabel>Last name</FormLabel>
                                        <Input name='last_name' type="text" value={customerForm.values.last_name} onChange={customerForm.handleChange} />
                                        {customerForm.errors.last_name && <Text fontSize='sm' color='red.400'>{customerForm.errors.last_name}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <HStack>
                                <Box>
                                    <FormControl id="phone" isRequired mb={customerForm.errors.phone ? 0 : 5}>
                                        <FormLabel>Phone number</FormLabel>
                                        <Input name='phone' type="text" value={customerForm.values.phone} onChange={customerForm.handleChange} />
                                        {customerForm.errors.phone && <Text fontSize='sm' color='red.400'>{customerForm.errors.phone}</Text>}
                                    </FormControl>
                                </Box>
                                <Box>
                                    <FormControl id="email" isRequired mb={customerForm.errors.email ? 0 : 5}>
                                        <FormLabel>Email</FormLabel>
                                        <Input name='email' type="email" value={customerForm.values.email} onChange={customerForm.handleChange} />
                                        {customerForm.errors.email && <Text fontSize='sm' color='red.400'>{customerForm.errors.email}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <FormControl id="address" isRequired mb={origin ? 3 : 5}>
                                <FormLabel>Address</FormLabel>
                                <GooglePlacesAutocomplete
                                    apiKey='AIzaSyCsvDO2ZMssvwhcmIo2TqXvJSL0zlMD5bw'
                                    apiOptions={{ region: 'za' }}
                                    selectProps={{
                                        placeholder: customer?.address,
                                        origin,
                                        onChange: setOrigin
                                    }}
                                />
                                {/* <Input name='address' type="text" value={companyForm.values.address} onChange={companyForm.handleChange} /> */}
                                {customer && <Text fontSize='sm' color='green.400'>{customer?.address}</Text>}
                                {(!origin && !customer ) && <Text fontSize='sm' color='red.400'>{'Enter your address'}</Text>}
                            </FormControl>
                            <Stack spacing={10} pt={2}>
                                <Button
                                    type='submit'
                                    isLoading={is_updating_customer}
                                    disabled={is_updating_customer || !customerForm.isValid}
                                    loadingText="Submitting"
                                    size="lg"
                                    colorScheme={'yellow'}
                                    >
                                    Submit
                                </Button>
                            </Stack>
                        </form>
                    </Stack>
                </Box>
            </Stack>
            <ToastContainer />
        </Flex>
    );
};